import { useState, useCallback, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FormHeader from "../Form/FormHeader";
import AgreementShowInfo from "./AgreementShowInfo";
import ReportShowInfo from "./ReportShowInfo";
import AgreementHistory from "./AgreementHistory";
import { getAgreement, getAgreementAnalyze } from "../../services/agreementServices";
import { generateAgreementPdf } from "../../pdfs/generateAgreementPdf";

export default function AgreementShow({ title, headerTitle }) {
  const { agreementId } = useParams();
  const location = useLocation();
  const { mainTitle } = location.state || {};

  const [agreement, setAgreement] = useState(null);
  const [signers, setSigners] = useState([]);
  const [report, setReport] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  // Cargar acuerdo
  const loadAgreement = useCallback(async () => {
    try {
      const response = await getAgreement(`/api/v1/agreements/${agreementId}`);
      setAgreement(response.data.data);
      setSigners(response.data.data.signers);
    } catch (err) {
      console.error("Error al cargar el acuerdo", err);
    }
  }, [agreementId]);

  // Cargar reporte
  const loadReport = useCallback(async () => {
    try {
      const response = await getAgreementAnalyze(agreementId);
      setReport(response.data);
    } catch (err) {
      console.error("Error al cargar análisis", err);
    }
  }, [agreementId]);

  useEffect(() => {
    if (agreementId) loadAgreement();
  }, [agreementId, loadAgreement]);

  // Cargar report solo si el acuerdo ya existe y no es borrador
  useEffect(() => {
    if (agreement && agreement.status !== "draft") loadReport();
  }, [agreement, loadReport]);

  if (!agreement) return <Typography>Cargando convenio...</Typography>;

  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  return (
    <Paper elevation={2} sx={{ padding: 3 }}>
      <FormHeader title={headerTitle || title || mainTitle} />

      <AgreementHistory
        extraButtons={
          <Button
            variant="outlined"
            size="medium"
            onClick={() => generateAgreementPdf(agreement, signers, report)}
          >
            Descargar convenio
          </Button>
        }
      />

      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Convenio" />
        {agreement.status !== "draft" && <Tab label="Análisis y Dictamen" />}
      </Tabs>

      {tabIndex === 0 && <AgreementShowInfo agreement={agreement} signers={signers} />}

      {tabIndex === 1 && agreement.status !== "draft" && (
        report ? (
          <ReportShowInfo report={report} />
        ) : (
          <Typography>Cargando análisis...</Typography>
        )
      )}
    </Paper>
  );
}
